import Heading from "components/ui/Heading/Heading";
import AddButton from "components/ui/Button/AddButton/AddButton";
import PaginationSearch from "components/ui/InputTypes/InputSearch/PaginationSearch/PaginationSearch";
import ComponentAccessControl from "components/essentials/ComponentAccessControl/ComponentAccessControl";
import { AUTOMATION_CREATE_PERMISSION } from "../permissions";
import "./AutomationsHeader.scss";

const AutomationsHeader = ({
    handleClick,
    handleSearch,
    searchIsLoading,
    clearSearch,
    defaultValue,
}) => {
    return (
        <>
            <Heading
                headingText='Automations'
                headingSubText='Run rule-based workflows across your tickets — checked every hour.'
            />
            <div className='automations-header'>
                <PaginationSearch
                    placeholder='Search automations here'
                    handleSearch={handleSearch}
                    searchIsLoading={searchIsLoading}
                    clearSearch={clearSearch}
                    defaultValue={defaultValue}
                />
                <ComponentAccessControl
                    baseResources={AUTOMATION_CREATE_PERMISSION}>
                    <AddButton
                        btnText='Create automation'
                        onClick={() => handleClick?.()}
                    />
                </ComponentAccessControl>
            </div>
        </>
    );
};

export default AutomationsHeader;
